export default "//cdn.scentbird.com/assets/frontbird-site/images/nest_6b7b41.png";